/**
 * Map API new-evidence signals → module banner view-model.
 */

function mapAction(action) {
    if (!action || typeof action !== 'object') return null;
    const key = action.key || action.action_type;
    if (!key) return null;
    return {
        key,
        label: action.label || action.title || key,
    };
}

function formatSourceBreakdown(context = {}) {
    const counts = context.source_type_counts || {};
    const delta = context.ready_source_delta ?? context.readySourceDelta;
    const parts = [];
    if (counts.vdr) parts.push(`${counts.vdr} VDR`);
    if (counts.irl) parts.push(`${counts.irl} IRL`);
    if (counts.observations) parts.push(`${counts.observations} Observations`);
    if (parts.length) return parts.join(' · ');
    if (delta != null && Number(delta) > 0) {
        return `${delta} new ready source${Number(delta) === 1 ? '' : 's'}`;
    }
    return null;
}

const DEFAULT_ACTIONS = [{ key: 'generate_new_version', label: 'Generate new version →' }];

const HIDDEN_NEW_EVIDENCE_ACTION_KEYS = new Set(['review_sources', 'review_evidence']);

export function mapNewEvidenceBanner(payload) {
    if (!payload || typeof payload !== 'object') return null;

    const resolution = payload.data?.new_evidence_resolution;
    if (resolution?.available) {
        const actions = (resolution.actions || [])
            .map(mapAction)
            .filter(action => action && !HIDDEN_NEW_EVIDENCE_ACTION_KEYS.has(action.key));
        return {
            title: 'New evidence available',
            message:
                resolution.message ||
                'New project sources are available since this analysis version was generated. Generate a new version from Overview to refresh all modules.',
            breakdown: formatSourceBreakdown(payload.context),
            actions: actions.length ? actions : DEFAULT_ACTIONS,
        };
    }

    const ne = payload.new_evidence;
    if (!ne?.available) return null;

    return {
        title: 'New evidence available',
        message:
            'New VDR, IRL, or Observations are available since this analysis version was generated. Generate a new version from Overview to refresh all modules.',
        breakdown: formatSourceBreakdown({ ...payload.context, ready_source_delta: ne.ready_source_delta }),
        affected:
            Array.isArray(ne.affected_modules) && ne.affected_modules.length
                ? `Affected modules: ${ne.affected_modules.join(', ')}`
                : null,
        actions: DEFAULT_ACTIONS,
    };
}
